const actions = {
  // generic actions
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  ADD_RECONCILIATION_MID_SETTING: 'ADD_RECONCILIATION_MID_SETTING',
  ADDING_RECONCILIATION_MID_SETTING: 'ADDING_RECONCILIATION_MID_SETTING',
  ADD_RECONCILIATION_MID_SETTING_SUCCESS: 'ADD_RECONCILIATION_MID_SETTING_SUCCESS',
  ADD_RECONCILIATION_MID_SETTING_FAILED: 'ADD_RECONCILIATION_MID_SETTING_FAILED',

  FETCH_RECONCILIATION_MID_SETTINGS: 'FETCH_RECONCILIATION_MID_SETTINGS',
  FETCHING_RECONCILIATION_MID_SETTINGS: 'FETCHING_RECONCILIATION_MID_SETTINGS',
  FETCH_RECONCILIATION_MID_SETTINGS_SUCCESS: 'FETCH_RECONCILIATION_MID_SETTINGS_SUCCESS',
  FETCH_RECONCILIATION_MID_SETTINGS_FAILED: 'FETCH_RECONCILIATION_MID_SETTINGS_FAILED',
  RESET_RECONCILIATION_MID_SETTINGS: 'RESET_RECONCILIATION_MID_SETTINGS',

  UPDATE_RECONCILIATION_MID_SETTING: 'UPDATE_RECONCILIATION_MID_SETTING',
  UPDATING_RECONCILIATION_MID_SETTING: 'UPDATING_RECONCILIATION_MID_SETTING',
  UPDATE_RECONCILIATION_MID_SETTING_SUCCESS: 'UPDATE_RECONCILIATION_MID_SETTING_SUCCESS',
  UPDATE_RECONCILIATION_MID_SETTING_FAILED: 'UPDATE_RECONCILIATION_MID_SETTING_FAILED',

  FETCH_PAYMENT_CHANNEL_REPORTS: 'FETCH_PAYMENT_CHANNEL_REPORTS',
  RESET_PAYMENT_CHANNEL_REPORTS: 'RESET_PAYMENT_CHANNEL_REPORTS',
  FETCHING_PAYMENT_CHANNEL_REPORTS: 'FETCHING_PAYMENT_CHANNEL_REPORTS',
  FETCH_PAYMENT_CHANNEL_REPORTS_SUCCESS: 'FETCH_PAYMENT_CHANNEL_REPORTS_SUCCESS',
  FETCH_PAYMENT_CHANNEL_REPORTS_FAILED: 'FETCH_PAYMENT_CHANNEL_REPORTS_FAILED',

  FETCH_PAYMENT_CHANNEL_RECORDS: 'FETCH_PAYMENT_CHANNEL_RECORDS',
  RESET_PAYMENT_CHANNEL_RECORDS: 'RESET_PAYMENT_CHANNEL_RECORDS',
  FETCHING_PAYMENT_CHANNEL_RECORDS: 'FETCHING_PAYMENT_CHANNEL_RECORDS',
  FETCH_PAYMENT_CHANNEL_RECORDS_SUCCESS: 'FETCH_PAYMENT_CHANNEL_RECORDS_SUCCESS',
  FETCH_PAYMENT_CHANNEL_RECORDS_FAILED: 'FETCH_PAYMENT_CHANNEL_RECORDS_FAILED',

  FETCH_FLOATING_RECORDS: 'FETCH_FLOATING_RECORDS',
  RESET_FLOATING_RECORDS: 'RESET_FLOATING_RECORDS',
  FETCHING_FLOATING_RECORDS: 'FETCHING_FLOATING_RECORDS',
  FETCH_FLOATING_RECORDS_SUCCESS: 'FETCH_FLOATING_RECORDS_SUCCESS',
  FETCH_FLOATING_RECORDS_FAILED: 'FETCH_FLOATING_RECORDS_FAILED',

  FETCH_POSSIBLE_MATCH_LIST: 'FETCH_POSSIBLE_MATCH_LIST',
  RESET_POSSIBLE_MATCH_LIST: 'RESET_POSSIBLE_MATCH_LIST',
  FETCHING_POSSIBLE_MATCH_LIST: 'FETCHING_POSSIBLE_MATCH_LIST',
  FETCH_POSSIBLE_MATCH_LIST_SUCCESS: 'FETCH_POSSIBLE_MATCH_LIST_SUCCESS',
  FETCH_POSSIBLE_MATCH_LIST_FAILED: 'FETCH_POSSIBLE_MATCH_LIST_FAILED',

  MATCH_MANUAL_TRX: 'MATCH_MANUAL_TRX',
  MATCHING_MANUAL_TRX: 'MATCHING_MANUAL_TRX',
  MATCH_MANUAL_TRX_SUCCESS: 'MATCH_MANUAL_TRX_SUCCESS',
  MATCH_MANUAL_TRX_FAILED: 'MATCH_MANUAL_TRX_FAILED',

  AMMEND_MANUAL_TRX: 'AMMEND_MANUAL_TRX',
  AMMENDING_MANUAL_TRX: 'AMMENDING_MANUAL_TRX',
  AMMEND_MANUAL_TRX_SUCCESS: 'AMMEND_MANUAL_TRX_SUCCESS',
  AMMEND_MANUAL_TRX_FAILED: 'AMMEND_MANUAL_TRX_FAILED',

  MANUAL_RECONCILE_TRX: 'MANUAL_RECONCILE_TRX',
  MANUAL_RECONCILE_TRX_LOADING: 'MANUAL_RECONCILE_TRX_LOADING',
  MANUAL_RECONCILE_TRX_SUCCESS: 'MANUAL_RECONCILE_TRX_SUCCESS',
  MANUAL_RECONCILE_TRX_FAILED: 'MANUAL_RECONCILE_TRX_FAILED',

  FETCH_RESOURCE_RECORDS: 'FETCH_RESOURCE_RECORDS',
  RESET_RESOURCE_RECORDS: 'RESET_RESOURCE_RECORDS',
  FETCHING_RESOURCE_RECORDS: 'FETCHING_RESOURCE_RECORDS',
  FETCH_RESOURCE_RECORDS_SUCCESS: 'FETCH_RESOURCE_RECORDS_SUCCESS',
  FETCH_RESOURCE_RECORDS_FAILED: 'FETCH_RESOURCE_RECORDS_FAILED',

  FETCH_HAS_L2_DEPENDENCY_RECORDS: 'FETCH_HAS_L2_DEPENDENCY_RECORDS',
  RESET_HAS_L2_DEPENDENCY_RECORDS: 'RESET_HAS_L2_DEPENDENCY_RECORDS',
  FETCHING_HAS_L2_DEPENDENCY_RECORDS: 'FETCHING_HAS_L2_DEPENDENCY_RECORDS',
  FETCH_HAS_L2_DEPENDENCY_RECORDS_SUCCESS: 'FETCH_HAS_L2_DEPENDENCY_RECORDS_SUCCESS',
  FETCH_HAS_L2_DEPENDENCY_RECORDS_FAILED: 'FETCH_HAS_L2_DEPENDENCY_RECORDS_FAILED',

  UPLOAD_RECON_FILE: 'UPLOAD_RECON_FILE',
  UPLOADING_RECON_FILE: 'UPLOADING_RECON_FILE',
  UPLOAD_RECON_FILE_SUCCESS: 'UPLOAD_RECON_FILE_SUCCESS',
  UPLOAD_RECON_FILE_FAILED: 'UPLOAD_RECON_FILE_FAILED',

  FETCH_RECON_FILES: 'FETCH_RECON_FILES',
  RESET_RECON_FILES: 'RESET_RECON_FILES',
  FETCHING_RECON_FILES: 'FETCHING_RECON_FILES',
  FETCH_RECON_FILES_SUCCESS: 'FETCH_RECON_FILES_SUCCESS',
  FETCH_RECON_FILES_FAILED: 'FETCH_RECON_FILES_FAILED',

  FETCH_REPORT_FILES: 'FETCH_REPORT_FILES',
  RESET_REPORT_FILES: 'RESET_REPORT_FILES',
  FETCHING_REPORT_FILES: 'FETCHING_REPORT_FILES',
  FETCH_REPORT_FILES_SUCCESS: 'FETCH_REPORT_FILES_SUCCESS',
  FETCH_REPORT_FILES_FAILED: 'FETCH_REPORT_FILES_FAILED',

  PROCESS_RECON_FILE_ACTION: 'PROCESS_RECON_FILE_ACTION',
  PROCESSING_RECON_FILE_ACTION: 'PROCESSING_RECON_FILE_ACTION',
  PROCESS_RECON_FILE_ACTION_SUCCESS: 'PROCESS_RECON_FILE_ACTION_SUCCESS',
  PROCESS_RECON_FILE_ACTION_FAILED: 'PROCESS_RECON_FILE_ACTION_FAILED',

  GENERATE_RECON_REPORT: 'GENERATE_RECON_REPORT',
  GENERATING_RECON_REPORT: 'GENERATING_RECON_REPORT',
  GENERATE_RECON_REPORT_SUCCESS: 'GENERATE_RECON_REPORT_SUCCESS',
  GENERATE_RECON_REPORT_FAILED: 'GENERATE_RECON_REPORT_FAILED',
  STORE_PENDING_RECON_REPORT_DATA: 'STORE_PENDING_RECON_REPORT_DATA',

  DOWNLOAD_RECONCILIATION_REPORT_DATA: 'DOWNLOAD_RECONCILIATION_REPORT_DATA',
  DOWNLOADING_RECONCILIATION_REPORT_DATA: 'DOWNLOADING_RECONCILIATION_REPORT_DATA',
  DOWNLOAD_RECONCILIATION_REPORT_DATA_SUCCESS: 'DOWNLOAD_RECONCILIATION_REPORT_DATA_SUCCESS',
  DOWNLOAD_RECONCILIATION_REPORT_DATA_FAILED: 'DOWNLOAD_RECONCILIATION_REPORT_DATA_FAILED',

  FETCH_FILE_FROM_PCHANNEL_REPORTS: 'FETCH_FILE_FROM_PCHANNEL_REPORTS',
  RESET_FILE_FROM_PCHANNEL_REPORTS: 'RESET_FILE_FROM_PCHANNEL_REPORTS',
  FETCHING_FILE_FROM_PCHANNEL_REPORTS: 'FETCHING_FILE_FROM_PCHANNEL_REPORTS',
  FETCH_FILE_FROM_PCHANNEL_REPORTS_SUCCESS: 'FETCH_FILE_FROM_PCHANNEL_REPORTS_SUCCESS',
  FETCH_FILE_FROM_PCHANNEL_REPORTS_FAILED: 'FETCH_FILE_FROM_PCHANNEL_REPORTS_FAILED',

  FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  FETCHING_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'FETCHING_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCCESS:
    'FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS',
  FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED:
    'FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED',

  RESET_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'RESET_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL',

  ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  ADDING_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'ADDING_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS: 'ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS',
  ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED: 'ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED',

  UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE:
    'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE',
  UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE:
    'UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE',
  UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_SUCCESS:
    'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_SUCCESS',
  UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED:
    'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED',

  FETCH_UPLOADED_FILES_REMITTANCE: 'FETCH_UPLOADED_FILES_REMITTANCE',
  FETCHING_UPLOADED_FILES_REMITTANCE: 'FETCHING_UPLOADED_FILES_REMITTANCE',
  FETCH_UPLOADED_FILES_REMITTANCE_SUCCESS: 'FETCH_UPLOADED_FILES_REMITTANCE_SUCCESS',
  FETCH_UPLOADED_FILES_REMITTANCE_FAILED: 'FETCH_UPLOADED_FILES_REMITTANCE_FAILED',

  FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA: 'FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA',
  FETCHING_REMITTANCE_UPLOADED_PCHANNEL_DATA: 'FETCHING_REMITTANCE_UPLOADED_PCHANNEL_DATA',
  FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_SUCCESS:
    'FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_SUCCESS',
  FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_FAILED: 'FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_FAILED',

  EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  EDITING_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'EDITING_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS: 'EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS',
  EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED: 'EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED',

  TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  TOGGLING_REMITTANCE_TEMPLATE_FROM_PCHANNEL: 'TOGGLING_REMITTANCE_TEMPLATE_FROM_PCHANNEL',
  TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS:
    'TOGGLING_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS',
  TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED:
    'TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED',

  RESET_REMITTANCE_UPLOADED_PCHANNEL_DATA: 'RESET_REMITTANCE_UPLOADED_PCHANNEL_DATA',

  FETCH_REMITTANCE_LOGS_FROM_PCHANNEL: 'FETCH_REMITTANCE_LOGS_FROM_PCHANNEL',
  FETCHING_REMITTANCE_LOGS_FROM_PCHANNEL: 'FETCHING_REMITTANCE_LOGS_FROM_PCHANNEL',
  FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_SUCCESS: 'FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_SUCCESS',
  FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_FAILED: 'FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_FAILED',

  RESET_REMITTANCE_LOGS_FROM_PCHANNEL: 'RESET_REMITTANCE_LOGS_FROM_PCHANNEL',

  FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA: 'FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA',
  FETCHING_FINANCE_DASHBOARD_PCHANNEL_DATA: 'FETCHING_FINANCE_DASHBOARD_PCHANNEL_DATA',
  FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_SUCCESS: 'FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_SUCCESS',
  FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_FAILED: 'FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_FAILED',

  DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS:
    'DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS',
  DELETING_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS:
    'DELETING_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS',
  DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_SUCCESS:
    'DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_SUCCESS',
  DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED:
    'DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED',

  GENERATE_SETTLEMENT_SUMMARY_REPORT: 'GENERATE_SETTLEMENT_SUMMARY_REPORT',
  GENERATING_SETTLEMENT_SUMMARY_REPORT: 'GENERATING_SETTLEMENT_SUMMARY_REPORT',
  GENERATE_SETTLEMENT_SUMMARY_REPORT_SUCCESS: 'GENERATE_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  GENERATE_SETTLEMENT_SUMMARY_REPORT_FAILED: 'GENERATE_SETTLEMENT_SUMMARY_REPORT_FAILED',

  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOAD_SETTLEMENT_SUMMARY_REPORT',
  DOWNLOADING_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOADING_SETTLEMENT_SUMMARY_REPORT',
  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS: 'DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED: 'DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED',

  FETCH_SETTLEMENT_SUMMARY_REPORT_DATA: 'FETCH_SETTLEMENT_SUMMARY_REPORT_DATA',
  FETCHING_SETTLEMENT_SUMMARY_REPORT_DATA: 'FETCHING_SETTLEMENT_SUMMARY_REPORT_DATA',
  FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS: 'FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS',
  FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED: 'FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED',

  APPROVE_SETTLEMENT_SUMMARY_REPORT: 'APPROVE_SETTLEMENT_SUMMARY_REPORT',
  APPROVING_SETTLEMENT_SUMMARY_REPORT: 'APPROVING_SETTLEMENT_SUMMARY_REPORT',
  APPROVE_SETTLEMENT_SUMMARY_REPORT_SUCCESS: 'APPROVE_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  APPROVE_SETTLEMENT_SUMMARY_REPORT_FAILED: 'APPROVE_SETTLEMENT_SUMMARY_REPORT_FAILED',

  REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT: 'REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT',
  REQUESTING_REVIEW_SETTLEMENT_SUMMARY_REPORT: 'REQUESTING_REVIEW_SETTLEMENT_SUMMARY_REPORT',
  REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    'REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_FAILED:
    'REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_FAILED',

  REJECT_SETTLEMENT_SUMMARY_REPORT: 'REJECT_SETTLEMENT_SUMMARY_REPORT',
  REJECTING_SETTLEMENT_SUMMARY_REPORT: 'REJECTING_SETTLEMENT_SUMMARY_REPORT',
  REJECT_SETTLEMENT_SUMMARY_REPORT_SUCCESS: 'REJECT_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  REJECT_SETTLEMENT_SUMMARY_REPORT_FAILED: 'REJECT_SETTLEMENT_SUMMARY_REPORT_FAILED',

  GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE: 'GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE',
  GENERATING_SUMMARY_BREAKDOWN_REPORT_REMITTANCE: 'GENERATING_SUMMARY_BREAKDOWN_REPORT_REMITTANCE',
  GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_SUCCESS:
    'GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_SUCCESS',
  GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_FAILED:
    'GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_FAILED',

  FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA:
    'FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA',
  FETCHING_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA:
    'FETCHING_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA',
  FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_SUCCESS:
    'FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_SUCCESS',
  FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_FAILED:
    'FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_FAILED',

  DOWNLOAD_REMITTANCE_SUMMARY_REPORT: 'DOWNLOAD_REMITTANCE_SUMMARY_REPORT',
  DOWNLOADING_REMITTANCE_SUMMARY_REPORT: 'DOWNLOADING_REMITTANCE_SUMMARY_REPORT',
  DOWNLOAD_REMITTANCE_SUMMARY_REPORT_SUCCESS: 'DOWNLOAD_REMITTANCE_SUMMARY_REPORT_SUCCESS',
  DOWNLOAD_REMITTANCE_SUMMARY_REPORT_FAILED: 'DOWNLOAD_REMITTANCE_SUMMARY_REPORT_FAILED',

  DOWNLOAD_UPLOADED_FILE_REMITTANCE: 'DOWNLOAD_UPLOADED_FILE_REMITTANCE',
  DOWNLOADING_UPLOADED_FILE_REMITTANCE: 'DOWNLOADING_UPLOADED_FILE_REMITTANCE',
  DOWNLOAD_UPLOADED_FILE_REMITTANCE_SUCCESS: 'DOWNLOAD_UPLOADED_FILE_REMITTANCE_SUCCESS',
  DOWNLOAD_UPLOADED_FILE_REMITTANCE_FAILED: 'DOWNLOAD_UPLOADED_FILE_REMITTANCE_FAILED',

  FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS:
    'FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS',
  FETCHING_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS:
    'FETCHING_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS',
  FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_SUCCESS:
    'FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_SUCCESS',
  FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_FAILED:
    'FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_FAILED',

  RESET_FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS:
    'RESET_FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS',

  GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA:
    'GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA',
  GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA:
    'GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA',
  GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_SUCCESS:
    'GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_SUCCESS',
  GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_FAILED:
    'GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_FAILED',

  GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE:
    'GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE',
  GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE:
    'GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE',
  GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS:
    'GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS',
  GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED:
    'GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED',

  DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE:
    'DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE',
  DOWNLOADING_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE:
    'DOWNLOADING_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE',
  DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS:
    'DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS',
  DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED:
    'DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED',

  FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA:
    'FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA',
  FETCHING_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA:
    'FETCHING_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA',
  FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_SUCCESS:
    'FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_SUCCESS',
  FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_FAILED:
    'FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_FAILED',

  CLEAR_DISCREPANCY_TAB_MESSAGE: 'CLEAR_DISCREPANCY_TAB_MESSAGE',

  FETCH_ROLLING_RESERVES: 'FETCH_ROLLING_RESERVES',
  FETCHING_ROLLING_RESERVES: 'FETCHING_ROLLING_RESERVES',
  FETCH_ROLLING_RESERVES_SUCCESS: 'FETCH_ROLLING_RESERVES_SUCCESS',
  FETCH_ROLLING_RESERVES_FAILED: 'FETCH_ROLLING_RESERVES_FAILED',

  UPDATE_RECON_GENERATED_REPORT_STATUS: 'UPDATE_RECON_GENERATED_REPORT_STATUS',
  UPDATING_RECON_GENERATED_REPORT_STATUS: 'UPDATING_RECON_GENERATED_REPORT_STATUS',
  UPDATE_RECON_GENERATED_REPORT_STATUS_SUCCESS: 'UPDATE_RECON_GENERATED_REPORT_STATUS_SUCCESS',
  UPDATE_RECON_GENERATED_REPORT_STATUS_FAILED: 'UPDATE_RECON_GENERATED_REPORT_STATUS_FAILED',

  CHECK_FILTERED_REMITTANCE_TRANSACTIONS: 'CHECK_FILTERED_REMITTANCE_TRANSACTIONS',
  CHECKING_FILTERED_REMITTANCE_TRANSACTIONS: 'CHECKING_FILTERED_REMITTANCE_TRANSACTIONS',
  CHECK_FILTERED_REMITTANCE_TRANSACTIONS_SUCCESS: 'CHECK_FILTERED_REMITTANCE_TRANSACTIONS_SUCCESS',
  CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED: 'CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED',

  TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET: 'TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET',
  TAGGING_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET:
    'TAGGING_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET',
  TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_SUCCESS:
    'TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_SUCCESS',
  TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_FAILED:
    'TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_FAILED',

  // UNMATCHED TRANSACTION MANAGEMENT ACTIONS
  FETCH_UNMATCHED_TRX: 'FETCH_UNMATCHED_TRX',
  FETCHING_UNMATCHED_TRX: 'FETCHING_UNMATCHED_TRX',
  FETCH_UNMATCHED_TRX_SUCCESS: 'FETCH_UNMATCHED_TRX_SUCCESS',
  FETCH_UNMATCHED_TRX_FAILED: 'FETCH_UNMATCHED_TRX_FAILED',

  FETCH_UNMATCHED_TRX_DETAILS: 'FETCH_UNMATCHED_TRX_DETAILS',
  FETCHING_UNMATCHED_TRX_DETAILS: 'FETCHING_UNMATCHED_TRX_DETAILS',
  FETCH_UNMATCHED_TRX_DETAILS_SUCCESS: 'FETCH_UNMATCHED_TRX_DETAILS_SUCCESS',
  FETCH_UNMATCHED_TRX_DETAILS_FAILED: 'FETCH_UNMATCHED_TRX_DETAILS_FAILED',

  PROCESS_UNMATCHED_TRX_REQUEST: 'PROCESS_UNMATCHED_TRX_REQUEST',
  PROCESSING_UNMATCHED_TRX_REQUEST: 'PROCESSING_UNMATCHED_TRX_REQUEST',
  PROCESS_UNMATCHED_TRX_REQUEST_SUCCESS: 'PROCESS_UNMATCHED_TRX_REQUEST_SUCCESS',
  PROCESS_UNMATCHED_TRX_REQUEST_FAILED: 'PROCESS_UNMATCHED_TRX_REQUEST_FAILED',

  ENDORSE_UNMATCHED_TRX: 'ENDORSE_UNMATCHED_TRX',
  ENDORSING_UNMATCHED_TRX: 'ENDORSING_UNMATCHED_TRX',
  ENDORSE_UNMATCHED_TRX_SUCCESS: 'ENDORSE_UNMATCHED_TRX_SUCCESS',
  ENDORSE_UNMATCHED_TRX_FAILED: 'ENDORSE_UNMATCHED_TRX_FAILED',

  UPDATE_UNMATCHED_TRX: 'UPDATE_UNMATCHED_TRX',
  UPDATING_UNMATCHED_TRX: 'UPDATING_UNMATCHED_TRX',
  UPDATE_UNMATCHED_TRX_SUCCESS: 'UPDATE_UNMATCHED_TRX_SUCCESS',
  UPDATE_UNMATCHED_TRX_FAILED: 'UPDATE_UNMATCHED_TRX_FAILED',

  FETCH_UNMATCHED_TRX_LOGS: 'FETCH_UNMATCHED_TRX_LOGS',
  LOADING_MORE_UNMATCHED_TRX_LOGS: 'LOADING_MORE_UNMATCHED_TRX_LOGS',
  FETCHING_UNMATCHED_TRX_LOGS: 'FETCHING_UNMATCHED_TRX_LOGS',
  FETCH_UNMATCHED_TRX_LOGS_SUCCESS: 'FETCH_UNMATCHED_TRX_LOGS_SUCCESS',
  FETCH_UNMATCHED_TRX_LOGS_FAILED: 'FETCH_UNMATCHED_TRX_LOGS_FAILED',
  RESET_UNMATCHED_TRX_LOGS: 'RESET_UNMATCHED_TRX_LOGS',

  FETCH_UPDATED_TRX: 'FETCH_UPDATED_TRX',
  FETCHING_UPDATED_TRX: 'FETCHING_UPDATED_TRX',
  FETCH_UPDATED_TRX_SUCCESS: 'FETCH_UPDATED_TRX_SUCCESS',
  FETCH_UPDATED_TRX_FAILED: 'FETCH_UPDATED_TRX_FAILED',

  NOTIFY_MERCHANT: 'NOTIFY_MERCHANT',
  NOTIFYING_MERCHANT: 'NOTIFYING_MERCHANT',
  NOTIFY_MERCHANT_SUCCESS: 'NOTIFY_MERCHANT_SUCCESS',
  NOTIFY_MERCHANT_FAILED: 'NOTIFY_MERCHANT_FAILED',

  FETCH_ASSIGNED_APPROVERS: 'FETCH_ASSIGNED_APPROVERS',
  FETCHING_ASSIGNED_APPROVERS: 'FETCHING_ASSIGNED_APPROVERS',
  FETCH_ASSIGNED_APPROVERS_SUCCESS: 'FETCH_ASSIGNED_APPROVERS_SUCCESS',
  FETCH_ASSIGNED_APPROVERS_FAILED: 'FETCH_ASSIGNED_APPROVERS_FAILED',

  MANAGE_APPROVER_DEPARTMENTS: 'MANAGE_APPROVER_DEPARTMENTS',
  MANAGING_APPROVER_DEPARTMENTS: 'MANAGING_APPROVER_DEPARTMENTS',
  MANAGE_APPROVER_DEPARTMENTS_SUCCESS: 'MANAGE_APPROVER_DEPARTMENTS_SUCCESS',
  MANAGE_APPROVER_DEPARTMENTS_FAILED: 'MANAGE_APPROVER_DEPARTMENTS_FAILED',

  UPDATE_RECONCILIATION_REMITTANCE_STATUS: 'UPDATE_RECONCILIATION_REMITTANCE_STATUS',
  UPDATING_RECONCILIATION_REMITTANCE_STATUS: 'UPDATING_RECONCILIATION_REMITTANCE_STATUS',
  UPDATE_RECONCILIATION_REMITTANCE_STATUS_SUCCESS:
    'UPDATE_RECONCILIATION_REMITTANCE_STATUS_SUCCESS',
  UPDATE_RECONCILIATION_REMITTANCE_STATUS_FAILED: 'UPDATE_RECONCILIATION_REMITTANCE_STATUS_FAILED',

  UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS: 'UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS',
  UPDATING_RESOURCE_TRANSACTION_REMITTANCE_STATUS:
    'UPDATING_RESOURCE_TRANSACTION_REMITTANCE_STATUS',
  UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_SUCCESS:
    'UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_SUCCESS',
  UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_FAILED:
    'UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_FAILED',

  REMITTANCE_ACTIONS_NOTIFIER: 'REMITTANCE_ACTIONS_NOTIFIER',

  CLEAR_REMITTANCE_MESSAGE: 'CLEAR_REMITTANCE_MESSAGE',
  CLEAR_REMITTANCE_ACTIONS_NOTIFIER: 'CLEAR_REMITTANCE_ACTIONS_NOTIFIER',

  FETCH_BANK_TEMPLATE_BY_PCHANNEL: 'FETCH_BANK_TEMPLATE_BY_PCHANNEL',
  FETCHING_BANKS_TEMPLATE_BY_PCHANNEL: 'FETCHING_BANKS_TEMPLATE_BY_PCHANNEL',
  FETCH_BANK_TEMPLATE_BY_PCHANNEL_SUCCESS: 'FETCH_BANK_TEMPLATE_BY_PCHANNEL_SUCCESS',
  FETCH_BANK_TEMPLATE_BY_PCHANNEL_FAILED: 'FETCH_BANK_TEMPLATE_BY_PCHANNEL_FAILED',

  EDIT_REMITTANCE_PCHANNEL_IDENTIFIER: 'EDIT_REMITTANCE_PCHANNEL_IDENTIFIER',
  EDITING_REMITTANCE_PCHANNEL_IDENTIFIER: 'EDITING_REMITTANCE_PCHANNEL_IDENTIFIER',
  EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS: 'EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS',
  EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED: 'EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED',

  REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER: 'REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER',
  REMOVING_REMITTANCE_PCHANNEL_IDENTIFIER: 'REMOVING_REMITTANCE_PCHANNEL_IDENTIFIER',
  REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS: 'REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS',
  REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED: 'REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED',

  ADD_REMITTANCE_PCHANNEL_IDENTIFIER: 'ADD_REMITTANCE_PCHANNEL_IDENTIFIER',
  ADDING_REMITTANCE_PCHANNEL_IDENTIFIER: 'ADDING_REMITTANCE_PCHANNEL_IDENTIFIER',
  ADD_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS: 'ADD_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS',
  ADD_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED: 'ADD_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED',

  GENERATE_REMITTANCE_RECONCILIATION_REPORT: 'GENERATE_REMITTANCE_RECONCILIATION_REPORT',
  GENERATING_REMITTANCE_RECONCILIATION_REPORT: 'GENERATING_REMITTANCE_RECONCILIATION_REPORT',
  GENERATE_REMITTANCE_RECONCILIATION_REPORT_SUCCESS:
    'GENERATE_REMITTANCE_RECONCILIATION_REPORT_SUCCESS',
  GENERATE_REMITTANCE_RECONCILIATION_REPORT_FAILED:
    'GENERATE_REMITTANCE_RECONCILIATION_REPORT_FAILED',

  DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT: 'DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT',
  DOWNLOADING_REMITTANCE_RECONCILIATION_REPORT: 'DOWNLOADING_REMITTANCE_RECONCILIATION_REPORT',
  DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_SUCCESS:
    'DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_SUCCESS',
  DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_FAILED:
    'DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_FAILED',

  FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT:
    'FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT',
  FETCHING_GENERATED_REMITTANCE_RECONCILIATION_REPORT:
    'FETCHING_GENERATED_REMITTANCE_RECONCILIATION_REPORT',
  FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_SUCCESS:
    'FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_SUCCESS',
  FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_FAILED:
    'FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_FAILED',

  FETCH_EXCEPTION_TRX: 'FETCH_EXCEPTION_TRX',
  FETCHING_EXCEPTION_TRX: 'FETCHING_EXCEPTION_TRX',
  FETCH_EXCEPTION_TRX_SUCCESS: 'FETCH_EXCEPTION_TRX_SUCCESS',
  FETCH_EXCEPTION_TRX_FAILED: 'FETCH_EXCEPTION_TRX_FAILED',
  
  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  addReconciliationMIDSetting: payload => ({
    type: actions.ADD_RECONCILIATION_MID_SETTING,
    payload
  }),

  fetchReconciliationMIDSettings: payload => ({
    type: actions.FETCH_RECONCILIATION_MID_SETTINGS,
    payload
  }),

  updateReconciliationMIDSetting: payload => ({
    type: actions.UPDATE_RECONCILIATION_MID_SETTING,
    payload
  }),

  fetchPaymentChannelReports: payload => ({
    type: actions.FETCH_PAYMENT_CHANNEL_REPORTS,
    payload: payload
  }),

  fetchPaymentChannelRecord: payload => ({
    type: actions.FETCH_PAYMENT_CHANNEL_RECORDS,
    payload: payload
  }),
  fetchFloatingRecord: payload => ({
    type: actions.FETCH_FLOATING_RECORDS,
    payload: payload
  }),
  resetFloatingRecord: () => ({
    type: actions.RESET_FLOATING_RECORDS
  }),
  fetchPossibleMatchList: payload => ({
    type: actions.FETCH_POSSIBLE_MATCH_LIST,
    payload: payload
  }),
  resetPossibleMatchList: () => ({
    type: actions.RESET_POSSIBLE_MATCH_LIST
  }),
  matchManualTrx: payload => ({
    type: actions.MATCH_MANUAL_TRX,
    payload: payload
  }),
  manualReconcileTrx: payload => ({
    type: actions.MANUAL_RECONCILE_TRX,
    payload: payload
  }),
  ammendTrxToFloating: payload => ({
    type: actions.AMMEND_MANUAL_TRX,
    payload: payload
  }),
  resetPaymentChannelRecord: () => ({
    type: actions.RESET_PAYMENT_CHANNEL_RECORDS
  }),

  fetchResourceRecord: payload => ({
    type: actions.FETCH_RESOURCE_RECORDS,
    payload: payload
  }),

  fetchL2DependencyRecord: payload => ({
    type: actions.FETCH_HAS_L2_DEPENDENCY_RECORDS,
    payload
  }),
  resetResourceRecord: () => ({
    type: actions.RESET_RESOURCE_RECORDS
  }),

  uploadFilesRequest: payload => ({
    type: actions.UPLOAD_RECON_FILE,
    payload
  }),

  fetchReconFiles: payload => ({
    type: actions.FETCH_RECON_FILES,
    payload
  }),
  fetchReportFiles: payload => ({
    type: actions.FETCH_REPORT_FILES,
    payload
  }),
  processReconFileAction: payload => ({
    type: actions.PROCESS_RECON_FILE_ACTION,
    payload
  }),
  resetReconFiles: () => ({
    type: actions.RESET_RECON_FILES
  }),
  resetReportFiles: () => ({
    type: actions.RESET_REPORT_FILES
  }),

  generateReconReport: payload => ({
    type: actions.GENERATE_RECON_REPORT,
    payload
  }),

  downloadReconciliationReport: payload => ({
    type: actions.DOWNLOAD_RECONCILIATION_REPORT_DATA,
    payload
  }),

  fetchFilesFromPchannelReports: payload => ({
    type: actions.FETCH_FILE_FROM_PCHANNEL_REPORTS,
    payload: payload
  }),

  resetFileListReport: () => ({
    type: actions.RESET_FILE_FROM_PCHANNEL_REPORTS
  }),

  resetPChannelReports: () => ({
    type: actions.RESET_PAYMENT_CHANNEL_REPORTS
  }),

  fetchAllRemittanceTemplateFromPchannel: payload => ({
    type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
    payload: payload
  }),

  resetAllRemittanceFromPchannel: () => ({
    type: actions.RESET_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL
  }),

  addRemittanceTemplateFromPchannel: payload => ({
    type: actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
    payload
  }),

  editRemittanceTemplateFromPchannel: payload => ({
    type: actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
    payload
  }),

  toggleStatusRemittanceTemplateFromPchannel: payload => ({
    type: actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
    payload
  }),

  uploadMultipleFileDataRemittance: (urls, payload, pagination) => ({
    type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE,
    urls,
    payload,
    pagination
  }),

  fetchAllUploadedFilesRemittance: (payload, pagination) => ({
    type: actions.FETCH_UPLOADED_FILES_REMITTANCE,
    payload,
    pagination
  }),

  fetchRemittanceUploadedPchannelData: (payload, pagination) => ({
    type: actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA,
    payload,
    pagination
  }),

  resetRemittanceUploadedPchannelData: () => ({
    type: actions.RESET_REMITTANCE_UPLOADED_PCHANNEL_DATA
  }),

  fetchRemittanceLogs: (payload, pagination) => ({
    type: actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL,
    payload,
    pagination
  }),

  resetRemittanceLogs: () => ({
    type: actions.RESET_REMITTANCE_LOGS_FROM_PCHANNEL
  }),

  fetchFinanceDashboardPchannelData: (payload, pagination) => ({
    type: actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA,
    payload,
    pagination
  }),

  deleteUploadedRemittanceFileAndTransactions: payload => ({
    type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS,
    payload
  }),

  generateSettlementSummaryReport: payload => ({
    type: actions.GENERATE_SETTLEMENT_SUMMARY_REPORT,
    payload
  }),

  downloadSettlementSummaryReport: (payload, pagination) => ({
    type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT,
    payload,
    pagination
  }),

  fetchSettlementSummaryReportData: (payload, pagination) => ({
    type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA,
    payload,
    pagination
  }),

  requestReviewSettlementSummaryReport: (urls, payload) => ({
    type: actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT,
    urls,
    payload
  }),

  rejectSettlementSummaryReport: payload => ({
    type: actions.REJECT_SETTLEMENT_SUMMARY_REPORT,
    payload
  }),

  approveSettlementSummaryReport: (urls, payload) => ({
    type: actions.APPROVE_SETTLEMENT_SUMMARY_REPORT,
    urls,
    payload
  }),

  generateSummaryBreakdownReportRemittance: payload => ({
    type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE,
    payload
  }),

  fetchAllGeneratedRemittanceSummaryReportData: (payload, pagination) => ({
    type: actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA,
    payload,
    pagination
  }),

  downloadRemittanceSummaryReport: payload => ({
    type: actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT,
    payload
  }),

  downloadUploadedFileRemittance: payload => ({
    type: actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE,
    payload
  }),

  fetchGeneratedPaymentChannelDiscrepancyReportAndBankTransactions: (payload, pagination) => ({
    type: actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS,
    payload,
    pagination
  }),

  resetGeneratedPaymentChannelDiscrepancyReportAndBankTransactions: () => ({
    type: actions.RESET_FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS
  }),

  generatePaymentChannelRemittanceDiscrepancyData: payload => ({
    type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA,
    payload
  }),

  generatePaymentChannelRemittanceDiscrepancyBreakdownReportFile: payload => ({
    type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE,
    payload
  }),
  downloadGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile: payload => ({
    type: actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE,
    payload
  }),

  fetchAllGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileData: (
    payload,
    pagination
  ) => ({
    type: actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA,
    payload,
    pagination
  }),

  clearDiscrepancyTabMessage: () => ({
    type: actions.CLEAR_DISCREPANCY_TAB_MESSAGE
  }),

  fetchRollingReserves: (payload, pagination) => ({
    type: actions.FETCH_ROLLING_RESERVES,
    payload,
    pagination
  }),

  fetchUnmatchedTransactions: payload => ({
    type: actions.FETCH_UNMATCHED_TRX,
    payload
  }),

  getUnmatchedTrxDetails: payload => ({
    type: actions.FETCH_UNMATCHED_TRX_DETAILS,
    payload
  }),

  processUnmatchedTrxRequestVote: (payload, filter) => ({
    type: actions.PROCESS_UNMATCHED_TRX_REQUEST,
    payload,
    filter
  }),

  endorseUnmatchedTransactions: (payload, filter) => ({
    type: actions.ENDORSE_UNMATCHED_TRX,
    payload,
    filter
  }),

  updateUnmatchedTrx: (payload, filter) => ({
    type: actions.UPDATE_UNMATCHED_TRX,
    payload,
    filter
  }),

  fetchUpdatedTrx: payload => ({
    type: actions.FETCH_UPDATED_TRX,
    payload
  }),

  notifyMerchant: (payload, filter) => ({
    type: actions.NOTIFY_MERCHANT,
    payload,
    filter
  }),

  fetchUnmatchedTrxLogs: payload => ({
    type: actions.FETCH_UNMATCHED_TRX_LOGS,
    payload
  }),

  fetchAssignedApprovers: () => ({
    type: actions.FETCH_ASSIGNED_APPROVERS
  }),

  manageApproverDepartments: payload => ({
    type: actions.MANAGE_APPROVER_DEPARTMENTS,
    payload
  }),

  fetchExceptionTrx: payload => ({
    type: actions.FETCH_EXCEPTION_TRX,
    payload
  }),

  updateReconGeneratedReportStatus: payload => ({
    type: actions.UPDATE_RECON_GENERATED_REPORT_STATUS,
    payload
  }),

  checkFilteredRemittanceTransactions: payload => ({
    type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS,
    payload
  }),

  tagFilteredRemittanceTransactionsAsOffset: payload => ({
    type: actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET,
    payload
  }),

  updateReconciliationRemittanceStatus: payload => ({
    type: actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS,
    payload
  }),

  updateResourceTransactionRemittanceStatus: payload => ({
    type: actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS,
    payload
  }),

  clearRemittanceMessage: () => ({
    type: actions.CLEAR_REMITTANCE_MESSAGE
  }),

  clearRemittanceActionNotifier: () => ({
    type: actions.CLEAR_REMITTANCE_ACTIONS_NOTIFIER
  }),

  fetchBankTemplateByPChannel: payload => ({
    type: actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL,
    payload
  }),

  editRemittancePChannelIdentifier: (id, payload) => ({
    type: actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER,
    id,
    payload
  }),

  removePChannelFromTemplateIdentifier: (id, payload) => ({
    type: actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER,
    id,
    payload
  }),

  addPChannelFromTemplateIdentifier: (id, payload) => ({
    type: actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER,
    id,
    payload
  }),

  generateRemittanceReconciliationReport: payload => ({
    type: actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT,
    payload
  }),

  downloadRemittanceReconciliationReport: id => ({
    type: actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT,
    id
  }),

  fetchGeneratedRemittanceReconciliationReport: (payload, pagination) => ({
    type: actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT,
    payload,
    pagination
  })
};
export default actions;
